// <s-back-to-top> reveals its button once the shopper has scrolled down, and scrolls the page
// back to the top on click (instantly when the shopper prefers reduced motion).
class BackToTop extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const button = this.querySelector("button");
    if (!button) return;

    const update = () => {
      this.toggleAttribute("data-visible", window.scrollY > 600);
    };
    window.addEventListener("scroll", update, { passive: true, signal });
    update();

    button.addEventListener(
      "click",
      () => {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
        document.getElementById("main-content")?.focus({ preventScroll: true });
      },
      { signal },
    );
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get("s-back-to-top")) {
  customElements.define("s-back-to-top", BackToTop);
}
